module.exports = __webpack_public_path__ + "img/arch_icon3.5e677100.png";